<script setup lang="ts">
const { cards } = defineProps<{ cards: { src: string, alt: string }[] }>()
</script>

<template>
  <div class="container z-10">
    <div class="relative md:px-16 flex flex-col perspective-midrange" :style="{ marginBottom: `calc(-10dvw * ${cards.length - 1})` }">
      <HomeHeroSectionMockupSlideshowCard
        v-for="(card, index) in cards"
        :key="card.src"
        :src="card.src"
        :alt="card.alt"
        :class="{ 'translate-y-[-10dvw]': index !== 0 }"
      />
    </div>
  </div>
</template>
